import { useEffect, useState } from 'react'
import { useSelectionStore } from '@/stores'

export interface GraphViewSidebarState {
  /** Whether the investigation detail sidebar is currently open. */
  sidebarOpen: boolean
  /** Imperative setter, wired to the canvas/sidebar open-change handlers. */
  setSidebarOpen: (open: boolean) => void
}

/**
 * Owns the graph view's sidebar visibility.
 *
 * Starts collapsed so the sidebar doesn't shadow the graph on entry, then
 * auto-opens whenever the user selects an entity or edge so the detail they
 * just picked is always visible. Manual expand/collapse still flows through
 * `setSidebarOpen`.
 */
export function useGraphViewSidebar(): GraphViewSidebarState {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const selectedEntityIds = useSelectionStore(s => s.selectedEntityIds)
  const selectedEdgeId = useSelectionStore(s => s.selectedEdgeId)

  useEffect(() => {
    if (selectedEntityIds.size > 0 || selectedEdgeId) setSidebarOpen(true)
  }, [selectedEntityIds, selectedEdgeId])

  return { sidebarOpen, setSidebarOpen }
}
